import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources"
import Event from "../../model2/event/event"
import {UpdateAction, UpdateType} from "../../gd/manager/delta-handler/types"

// const debug = "EventsResourcesCollection"
const debug = false

export default class EventsResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, Event, options)
    }

    processUpdate(update:UpdateAction):boolean {
        debug && console.log(debug, "processUpdate()", update)

        // New
        if (update.updateType === UpdateType.EVENT_NEW) {

            const event : Event = new Event(update.payload)
            this.add(event)

            return true // collection changed
        }

        // Change/Delete
        const event: Event | undefined = this.get(update.payload.id)

        // not found ? -> no update
        if (!event) {
            return false
        }

        if (update.updateType === UpdateType.EVENT_DELTA) {
            return event.applyDelta(update.payload)
        }

        if (update.updateType === UpdateType.EVENT_DELETE) {
            this.remove(update.payload.id)
            return true // deleted = changed
        }

        // should never get heres
        return false // not changed
    }
}